import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';


//获取入库申请列表
export async function getWarehousingList(params) {
    return post(erpserver+'/warehousing/getWarehousingList', params, true)
}



//保存
export async function saveWarehousing(params) {
    return post(erpserver+'/warehousing/saveWarehousing', params, true);
}
//产品列表
export async function getWarehousingProductList(params) {
    return post(erpserver+'/warehousing/getWarehousingProductList', params, true);
}
//查看
export async function getWarehousingForm(params) {
    return post(erpserver+'/warehousing/getWarehousingForm', params, true);
}
